import {INFO_BACKGROUND, INFO_COLOR} from "../../../../../../../../../themes/themeConfigurator";

const styles = theme => ({
  stepInfoText: {
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    marginBottom: 16,

    '&.newDesign': {
      display: 'flex',
      fontFamily: 'Roboto-Regular',
      background: INFO_BACKGROUND,
      border: '1px solid #B5BBC2',
      borderLeft: `6px solid ${INFO_COLOR}`,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(4),
      marginBottom: 0,

      '& .fa-info-circle': {
        fontSize: '1.3em',
        color: INFO_COLOR,
        paddingRight: theme.spacing(1),
      }
    }
  },
});

export default styles;